// extracted by mini-css-extract-plugin
export default {"mainIcon":"MainIcon_mainIcon__dxTvj"};